// apps/web/src/components/api-keys/ApiKeysManager.tsx
// API key management for integrations.

import { ManagerPage } from '../platform/ManagerPage.js';
import type { ApiKey } from '../../types/platform.js';

export function ApiKeysManager() {
  return (
    <ManagerPage
      title="API Keys"
      listPath="/api/v1/api-keys"
      listKey="keys"
      createLabel="Create Key"
      className="api-keys-manager"
      renderItem={(raw) => {
        const k = raw as ApiKey;
        return (
          <div className="manager-card" key={k.id}>
            <h3>{k.name}</h3>
            <p className="status-badge">{k.status}</p>
            <p className="mono">{k.keyPrefix}…</p>
            <p>{k.lastUsedAt ? `Last used ${k.lastUsedAt}` : 'Never used'}</p>
            <div className="actions">
              <button className="btn btn-secondary">Regenerate</button>
              <button className="btn btn-danger">Revoke</button>
            </div>
          </div>
        );
      }}
    />
  );
}